import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

const COPY = {
  active: ["Enable account", "Billing, linking and payments resume for this account."],
  disabled: ["Disable account", "Billing uploads, new links and mobile payments are blocked until it is enabled again. Existing links stay."],
  deactivated: ["Deactivate account permanently", "This cannot be undone. All app links to this account are removed and it can no longer be billed or paid."],
};

export function AccountStatusDialog({ target, onClose, onDone }) {
  const [reason, setReason] = useState("");
  useEffect(() => { setReason(""); }, [target]);
  if (!target) return null;
  const [title, desc] = COPY[target.status];
  const submit = async () => {
    try { await api.patch(`/accounts/${target.account.id}/status`, { status: target.status, reason }); toast.success("Account status updated"); setReason(""); onDone(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="account-status-dialog">
        <DialogHeader><DialogTitle>{title} · {target.account.account_number}</DialogTitle><DialogDescription>{desc}</DialogDescription></DialogHeader>
        <Textarea placeholder="Reason (required, at least 5 characters)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="account-status-reason" />
        <DialogFooter><Button variant={target.status === "deactivated" ? "destructive" : "default"} disabled={reason.trim().length < 5} onClick={submit} data-testid="account-status-submit">Confirm</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
